<template>
  <div>
    <!-- start: page -->
    <form
      class="ecommerce-form action-buttons-fixed"
      @submit.prevent="submitForm"
    >
      <div class="row">
        <div class="col">
          <section class="card card-modern card-big-info">
            <div class="card-body">
              <div class="row">
                <div class="col-lg-2-5 col-xl-1-5">
                  <i class="card-big-info-icon bx bx-slider"></i>
                  <h2 class="card-big-info-title">
                    {{ translations.detailsInfo }}
                  </h2>
                  <p class="card-big-info-desc">
                    {{ translations.details }}
                  </p>
                </div>

                <div class="col-lg-3-5 col-xl-4-5">
                  <div
                    class="form-group row align-items-center mb-3"
                    :class="{ 'has-danger': $v.brand.title.$anyError }"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                      >Naziv</label
                    >
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Naziv"
                        v-model="brand.title"
                      />
                      <form-error
                        :model="$v.brand.title"
                        :dirty="$v.$dirty"
                        label="Naziv"
                      />
                    </div>
                  </div>

                  <div
                    class="form-group row align-items-center pb-3"
                    :class="{ 'has-danger': $v.brand.topBrandItems.$anyError }"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Brendovi
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <div>
                        <treeselect
                          v-model="brand.topBrandItems"
                          :multiple="true"
                          :options="brands"
                          :show-count="true"
                          placeholder="Izaberite brend"
                        />
                        <form-error
                          :model="$v.brand.topBrandItems"
                          :dirty="$v.$dirty"
                          label="Brendovi"
                        />
                      </div>
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                      >Boja</label
                    >
                    <div class="col-lg-7 col-xl-6">
                      <input
                        v-model="brand.backgroundColour"
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Boja"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                      >Dostupno na</label
                    >
                    <div class="col-lg-7 col-xl-6">
                      <select
                        class="form-control form-control-modern"
                        v-model="brand.topBrandContentType"
                      >
                        <option
                          v-for="item in b2borb2cOptions"
                          :value="item.id"
                          :key="item.id"
                        >
                          {{ item.text }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="form-group row align-items-center mb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Zadana lista?
                    </label>
                    <div class="col-lg-7 col-xl-8">
                      <div class="switch switch-success">
                        <toggle-button :width="65" :height="35" color="#47a447" v-model="brand.currentlyHighlighted"/>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
      <div class="action-buttons d-flex justify-content-between">
        <div>
          <button
            type="button"
            data-bs-toggle="modal"
            data-bs-target="#delete-modal"
            class="delete-button btn btn-danger btn-px-4 py-3 d-flex align-items-center font-weight-semibold line-height-1">
            <i class="bx bx-trash text-4 me-2"></i> {{ translations.delete }}
          </button>
        </div>
        <div class="d-flex gap-3">
          <router-link
            exact
            :to="{ name: 'TopBrands' }"
            class="cancel-button btn btn-light btn-px-4 py-3 border font-weight-semibold text-color-dark text-3"
          >
            {{ translations.cancel }}
          </router-link>
          <button
            type="submit"
            class="submit-button btn btn-primary btn-px-4 py-3 d-flex align-items-center font-weight-semibold line-height-1"
          >
            <i class="bx bx-save text-4 me-2"></i> {{ translations.save }}
          </button>
        </div>
      </div>
      <modal id="delete-modal">
        <h5 slot="header"><strong>Ukloniti listu?</strong></h5>
        <div slot="body">
          <span>
            Jeste li sigurni da zelite ukloniti listu?
          </span>
        </div>
        <div slot="footer">
          <div class="row">
            <div class="col-md-12 text-end">
              <button type="button" class="btn btn-primary px-4 mx-2" @click.prevent.stop="deleteTopBrandList" data-bs-dismiss="modal">
                {{ translations.yes }}
              </button>
              <button type="button" class="btn btn-default px-4" data-bs-dismiss="modal">
                {{ translations.no }}
              </button>
            </div>
          </div>
        </div>
      </modal>
    </form>
    <!-- end: page -->
  </div>
</template>

<script>
import { ToggleButton } from 'vue-js-toggle-button';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';

import { translations } from '@/mixins';
import api from '@/services/api';
import Modal from '@/components/shared/modal/Modal.vue';
import validations from './validation-schema/edit';
import FormError from '../../shared/form-errors/FormError.vue';

export default {
  name: 'EditTopBrandList',
  mixins: [translations],
  validations,
  components: {
    ToggleButton,
    Treeselect,
    Modal,
    FormError,
  },
  data() {
    return {
      b2borb2cOptions: [
        {
          id: 1,
          text: 'B2B',
        },
        {
          id: 2,
          text: 'B2C',
        },
        {
          id: 3,
          text: 'Sve',
        },
      ],
    };
  },
  computed: {
    brands() {
      return this.$store.getters.getBrands.map(({ id, title }) => ({
        id,
        label: title,
      }));
    },
    brand() {
      return this.$store.getters.getTopBrand;
    },
  },
  methods: {
    submitForm() {
      this.$v.$touch();

      if (this.$v.$invalid) {
        this.$toast.error(this?.translations?.forms?.notValid);
        return;
      }

      const { brand } = this;

      api
        .updateTopBrandList(brand)
        .then((response) => {
          this.$toast.info(response?.data?.info);
          this.$router.push({ name: 'TopBrands' });
        })
        .catch((err) => {
          this.$toast.error(err?.response?.data?.info);
        });
    },
    deleteTopBrandList() {
      api
        .deleteTopBrandList(this.brand.id)
        .then((response) => {
          this.$toast.info(response.data.info);
          this.$router.push({ name: 'TopBrands' });
        })
        .catch((err) => {
          this.$toast.error(err?.response?.data?.info || 'Desila se greška');
        });
    },
  },
  mounted() {
    this.$store.dispatch('getBrands', {
      retrieveAll: true,
      sortBy: 'title',
      isSortAscending: true,
    });
  },
};
</script>
